<template>
  <article class="session-summary">
    <header class="session-summary__header">
      <cdr-text
        :tag="`h${titleLevel}`"
        class="session-summary__title"
      >
        {{ title }}
        <span
          v-if="note"
          :class="noteClasses"
        >
          {{ note }}
        </span>
      </cdr-text>
      <cdr-text
        class="session-summary__location"
        tag="span"
      >
        <icon-location-pin-fill class="session-summary__location-icon" />
        {{ location }}
      </cdr-text>
    </header>
    <ul
      ref="parentEl"
      :style="{ height: height, overflow: overflow }"
      class="session-summary__list show-more__item"
    >
      <li
        v-for="({ sessionId, time, link }, ix) in sessions"
        :key="sessionId"
        :ref="ref(ix, sessions.length)"
        :class="listItemClasses(ix)"
      >
        <cdr-text class="session-summary__time">
          {{ time }}
        </cdr-text>
        <cdr-link
          v-bind="link.attr"
          class="session-summary__cta"
          v-on="link.on"
        >
          {{ link.label }}
        </cdr-link>
      </li>
    </ul>
    <footer
      v-if="displayShowMore"
      class="session-summary__show-more"
    >
      <cdr-button
        modifier="link"
        class="session-summary__show-more-button"
        @click="toggleShowMore()"
      >
        {{ showMore }}
      </cdr-button>
    </footer>
  </article>
</template>
<script>
import { CdrButton, CdrText, CdrLink, IconLocationPinFill } from '@rei/cedar';
import { SEPARATOR, SOLD_OUT_SESSIONS } from '../stores/opoCourse/constants';
import showMore from '../mixins/showMore';

export default {
  name: 'SessionSummary',
  components: {
    CdrButton,
    CdrText,
    CdrLink,
    IconLocationPinFill,
  },
  mixins: [showMore],
  props: {
    titleKey: {
      type: String,
      required: true,
    },
    titleLevel: {
      type: Number,
      required: false,
      default: 3,
    },
    sessions: {
      type: Array,
      required: true,
    },
  },
  computed: {
    title() {
      const { titleKey } = this;
      return titleKey.split('|')[0];
    },
    isAlmostGone() {
      const { sessions } = this;

      const { almostGone: isAlmostGone } = sessions.reduce(
        ({ totalAvailable }, { available }, ix, { length }) => {
          const tA = totalAvailable + available;
          const aG = length > 1 ? tA <= length && tA > 0 : available <= 5 && available > 0;

          return {
            almostGone: aG,
            totalAvailable: tA,
          };
        },
        { almostGone: true, totalAvailable: 0 },
      );

      return isAlmostGone;
    },
    note() {
      const { title, isAlmostGone } = this;

      if (title === SOLD_OUT_SESSIONS) {
        return 'Waitlist only';
      }

      if (isAlmostGone) {
        return 'Almost gone';
      }

      return '';
    },
    noteClasses() {
      const { isAlmostGone } = this;

      return ['session-summary__title--note', isAlmostGone && 'session-summary__title--warning'];
    },
    location() {
      const { titleKey } = this;
      const split = titleKey.split(SEPARATOR);
      return split.length > 1 ? split[1] : '';
    },
    displayShowMore() {
      const { title, sessions, showMoreStartIx } = this;
      return title === SOLD_OUT_SESSIONS && sessions.length > showMoreStartIx;
    },
  },
  methods: {
    listItemClasses(ix) {
      const { isWailtist, title, showMoreClasses } = this;

      return [
        'session-summary__list-item',
        isWailtist && 'session-summary__list-item--waitlist',
        title === SOLD_OUT_SESSIONS && showMoreClasses(ix),
      ];
    },
  },
};
</script>
